module.exports = __webpack_public_path__ + "img/chuan.70916ea0.png";